import { Component, ElementRef, input, output, ViewChild } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AutomationIdDirective } from '@innogy/utils-automation-id';
import { SizeProp } from '@fortawesome/fontawesome-svg-core';

@Component({
  selector: 'wl-search-trigger',
  standalone: true,
  imports: [FontAwesomeModule, AutomationIdDirective],
  templateUrl: './search-trigger.component.html',
  styleUrls: ['./search-trigger.component.essent.scss'],
})
export class SearchTriggerComponent {
  readonly size = input<SizeProp>('1x');

  triggered = output<Event>();

  @ViewChild('buttonEl') buttonEl!: ElementRef<HTMLButtonElement>;

  clicked(event: Event) {
    this.triggered.emit(event);
  }

  public setFocus() {
    this.buttonEl.nativeElement.focus();
  }
}
